import Axios from 'axios';
import { PREFIX } from '../api-prefix';
import { formatQuery } from '../../utils/json';

/**
 * 知识库API
 */
export const knowledgeApi = {
    /**
     * 知识库树
     */
    async getTree () {
        return Axios.get(PREFIX.memPlatform + '/knowledgeCatalog/getAssitantKnowledgeCatalogTree');
    },
    /**
     * 知识库发布分页列表
     */
    getPublicDocumentPageList (params) {
        const str = formatQuery(params);
        return Axios.get(PREFIX.memPlatform + '/knowledge/page?' + str);
    },
    /**
     * 草稿区详情
     */
    async getDraftDocument (documentId) {
        return Axios.get(PREFIX.memPlatform + '/document/get?documentId=' + documentId);
    },
    /**
     * 获取草稿区知识库问答对列表
     */
    getQaList (params) {
        const str = formatQuery(params);
        return Axios.get(
            PREFIX.memPlatform + '/document/qaList?' + str
        );
    },
    getAssitantList () {
        return Axios.get(
            PREFIX.memPlatform + '/businessModel/assitantList'
        );
    },
    getBusinessModelList (params) {
        const str = formatQuery(params);
        return Axios.get(
            PREFIX.memPlatform + '/businessModel/page?' + str
        );
    }
};
